export default __webpack_public_path__ + "static/media/logo3.a59e6145.png";